import React from 'react';
import { Button } from '@fiverr-private/button';
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseBtn } from '@fiverr-private/overlay';
import { Container } from '@fiverr-private/layout_components';
import { AppI18n } from '../../i18n';

interface SubscribeModalProps {
    isOpen: boolean;
    onClose?: () => void;
    onConfirm?: () => void;
}

export const SubscribeModal: React.FC<SubscribeModalProps> = ({ isOpen, onClose, onConfirm }) => (
    <Modal isOpen={isOpen} onClose={onClose}>
        <ModalContent>
            <ModalHeader>
                <AppI18n k="steps.subscribe.modal.title" />
                <ModalCloseBtn />
            </ModalHeader>
            <ModalBody>
                <Container>
                    <AppI18n
                        k="steps.subscribe.modal.description"
                        templates={{ strong: (text) => <strong>{text}</strong> }}
                    />
                </Container>
            </ModalBody>
            <ModalFooter>
                <Button onClick={onConfirm}>
                    <AppI18n k="steps.subscribe.modal.cta" />
                </Button>
            </ModalFooter>
        </ModalContent>
    </Modal>
);

SubscribeModal.displayName = 'SubscribeModal';
